const mixin = {
  data() {
    return {
      Model: {
        transactorName: null,
        transactorSex: null,
        transactorAge: null,
        transactorCertigicateType: '身份证',
        transactorCertigicateNo: null,
        transactorPosition: null,
        transactorEmail: null,
        transactorCertificateValidity: null,
        transactorLandline: null,
        transactorMobile: null,
        transactorOfficeZip: null,
        transactorOfficeAddress: '',
        transactorProductRelation: null,
        isValidateForever: false,
      },
      options: {
        scrollToInvalidField: false,
      },
      Fields: [
        {
          type: 'input',
          modelKey: 'transactorName',
          label: '姓名',
          props: {
            type: 'text',
            readonly: true,
          },
          rules: {
            required: false,
          },
        },
        {
          type: 'input',
          modelKey: 'transactorCertigicateType',
          label: '证件类型',
          props: {
            type: 'text',
            readonly: true,
          },
          rules: {
            required: false,
          },
        },
        {
          type: 'input',
          modelKey: 'transactorCertigicateNo',
          label: '证件号码',
          props: {
            type: 'text',
            readonly: true,
          },
          rules: {
            required: false,
          },
        },
        {
          type: 'input',
          modelKey: 'transactorCertificateValidity',
          label: '证件有效期',
          props: {
            type: 'text',
            readonly: true,
          },
          rules: {
            required: false,
          },
        },
        {
          type: 'input',
          modelKey: 'transactorSex',
          label: '性别',
          props: {
            type: 'text',
            readonly: true,
          },
          rules: {
            required: false,
          },
        },
        {
          type: 'input',
          modelKey: 'transactorAge',
          label: '年龄',
          props: {
            type: 'text',
            readonly: true,
          },
          rules: {
            required: false,
          },
        },
        {
          type: 'input',
          modelKey: 'transactorPosition',
          label: '职务',
          props: {
            type: 'text',
            readonly: true,
          },
          rules: {
            required: false,
          },
        },
        {
          type: 'input',
          modelKey: 'transactorEmail',
          label: '电子邮箱',
          props: {
            type: 'text',
            readonly: true,
          },
          rules: {
            required: false,
          },
        },
        {
          type: 'input',
          modelKey: 'transactorLandline',
          label: '座机',
          props: {
            type: 'text',
            readonly: true,
          },
          rules: {
            required: false,
          },
        },
        {
          type: 'input',
          modelKey: 'transactorMobile',
          label: '手机',
          props: {
            type: 'text',
            readonly: true,
          },
          rules: {
            required: false,
          },
        },
        {
          type: 'input',
          modelKey: 'transactorOfficeZip',
          label: '办公邮编',
          props: {
            type: 'text',
            readonly: true,
          },
          rules: {
            required: false,
          },
        },
        {
          type: 'textarea',
          modelKey: 'transactorOfficeAddress',
          label: '办公住址',
          props: {
            type: 'text',
            readonly: true,
            placeholder: '',
          },
          rules: {
            required: false,
          },
        },
        {
          type: 'input',
          modelKey: 'transactorProductRelation',
          label: '与该机构/产品关系',
          props: {
            type: 'text',
            readonly: true,
          },
          rules: {
            required: false,
          },
        },
      ],
    };
  },
};
export default mixin;
